<template>
  <section class="pc-grid-section" aria-labelledby="pc-grid-heading-tws">
    <h2 id="pc-grid-heading-tws" class="pc-grid-title">
      {{ sectionTitle }}
    </h2>
    <div class="pc-grid-outer">
      <div class="pc-grid-big">
        <article
          v-for="(p, idx) in gridItemsBig"
          :key="'big-' + p.id + '-' + idx"
          class="pc-card-big"
        >
          <div class="pc-card-bg" :style="cardStyleBig(idx)" aria-hidden="true"></div>
          <div class="pc-card-meta">
          <img :src="require('@/assets/line.png')" alt="" class="pc-card-icon-big">
            <div class="pc-card-name-big" v-html="p.name"></div>
           
          </div>
        </article>
      </div>
      <div class="pc-grid">
        <article
          v-for="(p, idx) in gridItems"
          :key="'grid-' + p.id + '-' + idx"
          class="pc-card"
        >
          <div class="pc-card-bg" :style="cardStyle(idx)" aria-hidden="true"></div>
          <div class="pc-card-meta">
          <img :src="require('@/assets/line.png')" alt="" class="pc-card-icon-small">
            <div class="pc-card-name-small" v-html="p.name"></div>
          
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
const SMART_BG = [
  require('@/assets/tws4.png'),
  require('@/assets/tws5.png'),
  require('@/assets/tws6.png'),
  require('@/assets/tws7.png'),
  require('@/assets/tws8.png'),
  require('@/assets/tws9.png'),
  require('@/assets/tws10.png'),
  require('@/assets/tws11.png'),
  require('@/assets/tws12.png'),
  require('@/assets/tws13.png'),
]

const BIG_BG = [
  require('@/assets/tws1.png'),
  require('@/assets/tws2.png'),
  require('@/assets/tws3.png'),
]

export default {
  name: 'ProductCenterGridTws',
  data() {
    return {
      gridItemsBig: [
        {
          id: 'tws1',
          name: this.$t('productName.tws1'),
        },
        {
          id: 'tws2',
            name: this.$t('productName.tws2'),
        },
        {
          id: 'tws3',
          name: this.$t('productName.tws3'),
        },
      ],
      gridItems: [
        {
          id: 'tws4',
          name: this.$t('productName.tws4'),
        },
        {
          id: 'tws5',
          name: this.$t('productName.tws5'),
        },
        {
          id: 'tws6',
          name: this.$t('productName.tws6'),
        },
        {
          id: 'tws7',
          name: this.$t('productName.tws7'),
        },
        {
          id: 'tws8',
          name: this.$t('productName.tws8'),
        },
        {
          id: 'tws9',
          name: this.$t('productName.tws9'),
        },
        {
          id: 'tws10',
          name: this.$t('productName.tws10'),
        },
        {
          id: 'tws11',
          name: this.$t('productName.tws11'),
        },
        {
          id: 'tws12',
          name: this.$t('productName.tws12'),
        },
        {
          id: 'tws13',
          name: this.$t('productName.tws13'),
        },
      ],
    }
  },
  computed: {
    sectionTitle() {
      return this.$t('productCenter.titles.twsHeadphones')
    },
  },
  methods: {
    cardStyle(idx) {
      const url = SMART_BG[idx] || SMART_BG[0]
      return {
        backgroundImage: `url(${url})`,
      }
    },
    cardStyleBig(idx) {
      const url = BIG_BG[idx] || BIG_BG[0]
      return {
        backgroundImage: `url(${url})`,
      }
    },
  },
}
</script>

<style scoped lang="css">
.pc-card-name-small{
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 22px;
  margin-top: 15px;
  line-height: 26px;
  color: #454545;
}
.pc-card-name-big{
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 22px;
  color: #454545;
  line-height: normal;
  margin-top: 15px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.pc-card-icon-small{
        width: 100%;
        max-width: 223px;
        height: 4px;
    }
.pc-card-icon-big{
        width: 100%;
        max-width: 426px;
     
    }
.pc-grid-section {
  background: #EDEDED;
  padding: 48px 24px 72px;
  box-sizing: border-box;
}

.pc-grid-title {
  margin: 40px 0 70px 0;
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 38px;
  color: #282828;
  line-height: 33px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.pc-grid-outer {
  width: 100%;
  max-width: 1570px;
  margin: 0 auto;
  box-sizing: border-box;
}

.pc-grid {
  display: grid;
  grid-template-columns: repeat(5, 300px);
  gap: 29px;
  justify-content: center;
  width: 100%;
  max-width: 1570px;
  margin: 0 auto;
  box-sizing: border-box;
}

.pc-grid-big {
  display: grid;
  grid-template-columns: repeat(3, 504px);
  gap: 52px;
  justify-content: center;
  width: 100%;
  max-width: 1570px;
  margin: 0 auto 20px;
  box-sizing: border-box;
}

.pc-card-big {
  position: relative;
  width: 504px;
  height: 504px;
  max-width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  background-color: #e8e8e8;
}

.pc-card-name-big {
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 26px;
  line-height: 30px;
  color: #454545;
}

.pc-card {
  position: relative;
  width: 300px;
  height: 394px;
  max-width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  background-color: #e8e8e8;
}

.pc-card-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.45s ease;
  will-change: transform;
}

.pc-card-big:hover .pc-card-bg,
.pc-card:hover .pc-card-bg {
  transform: scale(1.06);
}

.pc-card-meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px 20px 22px 41px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  z-index: 1;
}

.pc-card-name {
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 22px;
  color: #454545;
  line-height: normal;
  margin-top: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.pc-card-cta {
  display: inline-flex;
  align-items: center;
  gap: 35px;
  padding: 5px 10px 5px 10px;
  background: #2563eb;
  font-weight: 300;
  font-size: 21px;
  color: #ffffff;
  line-height: 23px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  text-decoration: none;
  border-radius: 0;
  transition: background 0.2s ease;
}

.pc-card-cta:hover {
  background: #1d4ed8;
}

.pc-card-cta-arrow {
  width: 28px;
  height: 20px;
}

@media (max-width: 1600px) {
  .pc-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
  }

  .pc-card {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
}

@media (max-width: 1024px) {
  .pc-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .pc-grid-section {
    padding: 32px 16px 48px;
  }

  .pc-grid {
    grid-template-columns: 1fr;
  }
}
</style>
